import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getContainerLogsGetFilters as getContainerLogsApi,
  bulkDeleteContainerLogs as bulkDeleteApi,
} from "../../helpers/realbackend_helper";

export const getContainerLogs = createAsyncThunk(
  "logs/getContainerLogs",
  async (
    {
      action = "",
      priority = "",
      container_number = "",
      user_name = "",
      company_name = "",
      beginDate = "",
      endDate = "",
      conflicted = false,
      page = 1,
      pageSize = 30,
      append = false,
    } = {},
    { rejectWithValue }
  ) => {
    try {
      const response = await getContainerLogsApi({
        action,
        priority,
        container_number,
        user_name,
        company_name,
        beginDate,
        endDate,
        conflicted,
        page,
        pageSize,
      });
      return { ...response, append, page };
    } catch (err) {
      return rejectWithValue(err.message || "Failed to fetch logs");
    }
  }
);

export const bulkDeleteLogs = createAsyncThunk(
  "logs/bulkDeleteLogs",
  async (ids = [], { rejectWithValue }) => {
    try {
      await bulkDeleteApi(ids);
      return ids;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to delete logs");
    }
  }
);
